module.exports = {"slides":[{"icon":"f4_2_1","color":"turquoise","txt":"f4_slid_txt_1","txt_t_header":"f4_slid_h_1"},{"icon":"f4_2_2","color":"turquoise","txt":"f4_slid_txt_2","txt_t_header":"f4_slid_h_2"},{"icon":"f4_2_3","color":"turquoise","txt":"f4_slid_txt_3","txt_t_header":"f4_slid_h_3"},{"icon":"f4_2_4","color":"turquoise","txt":"f4_slid_txt_4","txt_t_header":"f4_slid_h_4"},{"icon":"f4_2_5","color":"turquoise","txt":"f4_slid_txt_5","txt_t_header":"f4_slid_h_5"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/fact_4_s.json
// module id = 5HGt
// module chunks = 1